const CHANNEL_TYPES = {
  whatsapp: 'WHATSAPP',
  melichat: 'MELICHAT',
  call: 'CALL',
  none: 'NONE',
};

module.exports = CHANNEL_TYPES;
